/* eslint-disable */

import React, { Component } from 'react';

import './AdThumbnail.css';
import placeholder from '../../../../assets/images/placeholder-image.jpg';

export default class AdThumbnail extends Component {
  constructor(props) {
    super(props);

    // there was a case where image was not properly set and size was too small.
    // filter image by size. If the image has height or widht less than 64, filter them out.
    this.state = {
      imageUrl: props.src,
      isImageValid: true
    };
  }

  render() {
    return (
      <div className="thumbnail-container" style={this.props.customStyle || {}}>
        <img
          style={this.props.imageCustomStyle || {}}
          src={this.state.isImageValid ? this.state.imageUrl : placeholder}
          ref={(element) => {
            this.imageRef = element;
          }}
          onLoad={() => {
            if (
              this.imageRef.naturalWidth < 64 ||
              this.imageRef.naturalHeight < 64
            ) {
              this.setState((prevState) => {
                return {
                  ...prevState,
                  isImageValid: false
                };
              });
            }
          }}
        ></img>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PresentaionAdList/AdThumbnail/AdThumbnail.jsx